<template>
  <div
    class="operation-record-page tb"
    v-if="funcView.isp_flow_use_record_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.isp_flow_use_record_export"
        >
          <el-button
            class="table-set"
            @click="exportTable"
            :disabled="isExportIng"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{ 'mr-0': !funcView.isp_flow_use_record_export }"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            placeholder="IMSI/ICCID"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('Common.com_date')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.operatorTime"
            :picker-options="pickerOptionsIntervalMonth"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_flowUseRecord.gong_ying_shang')">
          <el-input v-model="formSearch.supplierName" :placeholder="$t('dms_flowUseRecord.gong_ying_shang')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_flowUseRecord.suo_shu_guo_jia')">
          <el-input
            v-model="formSearch.lastCountryCode"
            :placeholder="$t('dms_flowUseRecord.suo_shu_guo_jia')"
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['lastSessionRecvData', 'lastSessionSendData', 'monthRecvLen']"
      >
        <template v-slot:lastSessionRecvData="scope">
          {{ formatDataFlow(scope.row.lastSessionRecvData) }}
        </template>
        <template v-slot:lastSessionSendData="scope">
          {{ formatDataFlow(scope.row.lastSessionSendData) }}
        </template>
        <template v-slot:monthRecvLen="scope">
          {{ formatDataFlow(scope.row.monthRecvLen) }}
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import moment from 'moment';

export default {
  name: 'ispStatusChangeRecord',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'isp_flow_use_record',
      dialogVisible: false,
      dialogModel: {},
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // 操作时间
        operatorTime: [this.$momentWorld(moment(this.$getLocalTime()).startOf('month').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))],
        // 所属国家
        lastCountryCode: '',
        supplierName: '',
      },
      tableList: [],
      totalRows: null,
      link: null,
      isExportIng: false
    };
  },
  activated: function () {},
  computed: {},
  watch: {},
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取格式流量
    // byte 转 kb
    formatDataFlow(val) {
      if (!val) {
        return 0;
      }

      const intVal = parseInt(val, 10);

      return Math.round(intVal / 1024);
    },
    exportTable() {
      const reqData = {
        ...this.formSearch,
      };
      const operatorTime = reqData.operatorTime;
      if (operatorTime && operatorTime.length) {
        const simDataStartDate = operatorTime[0];
        const simDataEndDate = operatorTime[1];
        reqData.simDataStartDate = simDataStartDate;
        reqData.simDataEndDate = simDataEndDate;
      }

      delete reqData.operatorTime;

      delete reqData.pageSize;
      delete reqData.pageNum;

      this.isExportIng = true;
      this.$exportFlie(apis.simIspDataExport, reqData).then(() => {
        this.isExportIng = false;
      }).catch(() => {
        this.isExportIng = false;
      });
    },
    getTableListReqData() {
      const ret = {
        ...this.formSearch,
      };

      const operatorTime = ret.operatorTime;
      if (operatorTime && operatorTime.length) {
        const simDataStartDate = operatorTime[0];
        const simDataEndDate = operatorTime[1];
        ret.simDataStartDate = simDataStartDate;
        ret.simDataEndDate = simDataEndDate;
      }

      delete ret.operatorTime;

      return ret;
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simIspDataPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.operation-record-page {
}
</style>
